import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SignatureSvg = function SignatureSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.028 4.214A2.47 2.47 0 0 1 7.78 3.48c.657 0 1.287.264 1.751.733.465.469.726 1.104.726 1.767v4.374c-1.765.52-3.735 1.29-5.302 2.381C3.323 13.872 2 15.451 2 17.556c0 1.178.464 2.309 1.29 3.142A4.38 4.38 0 0 0 6.404 22h.458c.639 0 1.271-.127 1.861-.374a4.9 4.9 0 0 0 1.578-1.063 4.946 4.946 0 0 0 1.424-3.47v-5.514c1.7-.054 3.173 1.229 3.56 3.18l.149.76h1.974l.602-1.216c.37-.747.94-1.376 1.645-1.816A4.43 4.43 0 0 1 22 11.815v-1.482a5.9 5.9 0 0 0-3.117.894 5.97 5.97 0 0 0-2.186 2.414l-.12.24c-.675-2.228-2.568-3.85-4.852-3.788V5.98a4 4 0 0 0-1.156-2.815A3.93 3.93 0 0 0 7.78 2C6.735 2 5.73 2.42 4.99 3.166a4 4 0 0 0-1.155 2.815v2.315h1.468V5.981c0-.663.26-1.298.725-1.767m-.24 9.742c1.274-.886 2.9-1.563 4.469-2.054v5.19a3.45 3.45 0 0 1-.994 2.423 3.4 3.4 0 0 1-2.4 1.003h-.46a2.92 2.92 0 0 1-2.075-.867 2.98 2.98 0 0 1-.86-2.095c0-1.4.867-2.589 2.32-3.6",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M13.743 19.222H22v-1.481h-8.257z"
    })]
  });
};
export var Signature = function Signature(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: SignatureSvg
  }));
};